<template>
  <div class='leftContent'>
    <div class='search'>
      <el-input type='text' style='width:200px' :placeholder="$t('public.please_enter')"
                v-model='keyword' clearable></el-input>
      <el-button @click='onSearch' type='primary' icon='el-icon-search' class='btnClass'
      ></el-button>
      <el-button type='primary' icon='el-icon-plus' class='btnClass' @click='typeAdd'></el-button>
    </div>
    <div class='content' ref='rightDiv'>
      <ul v-if='list.length > 0'>
        <li v-for='(item, index) in renderList' :key='item.id' :class="active === index ? 'active' : ''"
            @click='handleClick(item, index)'>

          <span>
            <span v-if='item.current'>★</span>
            {{ item[mapper.name] }}
          </span>
          <span>
              <i class='el-icon-edit' @click.stop='editFn(item)'></i>
              <i class='el-icon-delete' @click.stop='deleteFn(item, index)'></i>
          </span>
        </li>
        <div class='moreLoad'>
          <i class='el-icon-loading' v-show='loading'></i>
          <span v-show='flagText && !loading'>{{ $t('public.no_more') }}</span>
        </div>
      </ul>
      <el-empty v-else :description="$t('public.no_data')"></el-empty>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    list: {
      default: () => []
    },
    // 字段名映射表
    mapper: {
      type: Object,
      default: () => {
        return {
          name: 'name',
          id: 'id'
        }
      }
    }
  },
  watch: {
    list () {
      if (this.list.length) {
        this.active = 0
        this.$emit('select', this.list[0])
        this.renderList = [...this.list]
      }
    }
  },
  data () {
    return {
      loading: false,
      // 默认选择
      active: 0,
      // no more
      flagText: false,
      // 搜索关键字
      keyword: '',
      renderList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 一定要加这个true  否则滚动无效
      window.addEventListener('scroll', this.handleScroll, true)
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll, true)
  },

  methods: {
    searchTree () {
      this.$emit('search', this.keyword)
    },
    typeAdd () {
      this.$emit('add')
    },
    handleScroll (e) {
      // 滚动的像素+容器的高度>可滚动的总高度-20像素
      const scrollTop = this.$refs.rightDiv.scrollTop
      // 获取可视区的高度
      const windowHeight = this.$refs.rightDiv.clientHeight
      // 获取滚动条的总高度
      const scrollHeight = this.$refs.rightDiv.scrollHeight

      if (scrollTop + windowHeight >= scrollHeight) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
        // 调用函数
        // this.listQuery.iDisplayStart += 50
        // this.listQuery.iDisplayLength = 50
        this.loading = true
        // 这里也可以使用总数  感觉总数好点
        if (this.flagText) return (this.loading = false)
        // if (this.total<=this.letContent.length) return this.loading = false,this.flagText = true;
        this.loading = true
      }
    },
    handleClick (item, index) {
      this.active = index
      this.$emit('select', item)
    },
    // 编辑
    editFn (item) {
      this.$emit('edit', item)
    },
    // 删除
    deleteFn (item, index) {
      this.$emit('delete', item)
    },
    onSearch () {
      this.renderList = this.list.filter(item => {
        if (item[this.mapper.name].indexOf(this.keyword) !== -1) {
          return true
        }
        return false
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.leftContent {
  width: 300px;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
  height: 100%;

  .search {
    width: 100%;
    height: 40px;
    margin: 0 0 5px 0;
    padding-left: 10px;
    border-bottom: 1px solid $borderColor3;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    ::v-deep .el-icon-plus {
      color: #fff !important;
    }
  }

  .content {
    height: calc(100% - 45px);
    overflow: auto;
    box-sizing: border-box;

    li {
      display: flex;
      padding: 0 10px;
      margin: 0 10px 5px 10px;
      height: 40px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      border-radius: 2px;

      i {
        cursor: pointer;
        margin-right: 5px;
        color: #ccc;

        &:hover {
          color: var(--primary-color);
        }
      }
    }

    .active {
      background-color: var(--primary-color);
      color: #fff;
    }
  }

  .moreLoad {
    text-align: center;
    font-size: 22px;
    line-height: 30px;
    // background-color: var(--primary-color);
  }
}
</style>
